package com.anjuros.website.templates.template5.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.shared.WaveDivider
import com.anjuros.website.templates.template5.modules.Template5Achievement
import com.anjuros.website.templates.template5.modules.Template5HeaderItem
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.modules.getColorOpacity
import com.anjuros.website.templates.template5.modules.getColorOpacity2
import com.anjuros.website.templates.template5.modules.getColorOpacity2Hex
import com.anjuros.website.templates.template5.modules.getColorOpacityHex
import com.anjuros.website.templates.template5.styles.Template5AboutImageStyle
import com.anjuros.website.templates.template5.util.ResKey
import com.anjuros.website.templates.template5.util.Template5CompanyDetails
import com.anjuros.website.templates.template5.util.Template5Constants
import com.anjuros.website.templates.template5.util.Template5ObserverViewportEntered
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template5AboutSection() {

    val animatedOpacity = remember {
        mutableStateOf(0.0f)
    }
    Template5ObserverViewportEntered(
        sectionId = Template5HeaderItem.ABOUT.id,
        distanceFromTop = 300.0
    ) {

        animatedOpacity.value = 1.0f
    }
    Column(
        modifier = Modifier
            .id(Template5HeaderItem.ABOUT.id)
            .fillMaxWidth()
            ,
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(
                    top= 120.px)
                .backgroundColor(Template5Theme.Background.getColorOpacity()),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Row(
                modifier = Modifier
                    .displayIfAtLeast(Breakpoint.LG)
                    .fillMaxWidth(85.percent),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {

                Template5AboutImage()

                Spacer()

                Template5AboutText(
                    modifier = Modifier
                        .weight(1f)
                        .margin(leftRight = 60.px),
                    opacity = animatedOpacity.value
                )

                Spacer()

                Template5AboutAchievements(
                    opacity = animatedOpacity.value
                )

            }

            Column(
                modifier = Modifier.fillMaxWidth(90.percent)
                    .displayUntil(Breakpoint.LG),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                Template5AboutImage()

                Spacer()

                Template5AboutText(
                    opacity = animatedOpacity.value
                )

                Spacer()

                Template5AboutAchievements(
                    opacity = animatedOpacity.value
                )

            }
        }
        WaveDivider(
            backgroundColor = Template5Theme.Background.getColorOpacityHex(),
            waveColor =Template5Theme.Background2.getColorOpacity2Hex()
        )

    }

}

@Composable
private fun Template5AboutImage() {

    Box(
        modifier = Modifier.position(Position.Relative),
        contentAlignment = Alignment.Center
    ) {

        AnjurosImage(
            modifier = Template5AboutImageStyle.toModifier()
                .border(
                    1.px,
                    LineStyle.Dashed,
                    Template5Theme.Secondary.getColor()
                )
                .align(Alignment.Center)
                .borderRadius(50.percent)
                .objectFit(ObjectFit.Cover),
            src = "template5_about.jpg",
            alt = "Emily"
        )

    }

}

@Composable
private fun Template5AboutText(
    modifier: Modifier = Modifier,
    opacity: Float
) {

    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.Start
    ) {

        Template5Badge(
            text = LocalText(ResKey.TEMPLATE5_ABOUT_BADGE)
        )

        Spacer()

        Template5ScriptHeading(
            opacity = opacity
        )

    }

}

@Composable
fun Template5ScriptHeading(
    opacity: Float
) {

    P(
        attrs = Modifier
            .fontSize(35.px)
            .opacity(opacity)
            .transition(Transition.of("opacity", 800.ms, delay = 100.ms))
            .lineHeight(1.9)
            .color(Template5Theme.Primary.getColor())
            .fontFamily(Template5Constants.FONT_FAMILY_CRAFT)
            .margin(top = 30.px, bottom = 10.px)
            .maxWidth(620.px)
            .toAttrs()
    ) {
        AnjurosText(LocalText( ResKey.TEMPLATE5_ABOUT_INTRO1), Template5CompanyDetails.CLIENTS_COMPANY_NAME)
    }
    Spacer()
    P(
        attrs = Modifier
            .fontSize(18.px)
            .opacity(opacity)
            .transition(Transition.of("opacity", 700.ms, delay = 800.ms))
            .lineHeight(1.9)
            .color(rgb(90, 90, 90))
            .margin(bottom = 15.px)
            .maxWidth(620.px)
            .toAttrs()
    ) {
        Text(LocalText(ResKey.TEMPLATE5_ABOUT_PARAGRAPH1))
    }

    Spacer()

    P(
        attrs = Modifier
            .fontSize(18.px)
            .opacity(opacity)
            .transition(Transition.of("opacity", 700.ms, delay = 1300.ms))
            .lineHeight(1.9)
            .color(rgb(90, 90, 90))
            .margin(bottom = 20.px)
            .maxWidth(620.px)
            .toAttrs()
    ) {
        Text(LocalText(ResKey.TEMPLATE5_ABOUT_PARAGRAPH2))
    }

    Spacer()
    P(
        attrs = Modifier
            .fontSize(28.px)
            .lineHeight(1.9)
            .scale(if(opacity==0.0f) 1.3 else 1.0)
            .opacity(opacity)
            .transition(Transition.of("opacity", 900.ms, delay = 1900.ms),
                Transition.of("scale", 900.ms, delay = 2000.ms))
            .color(Template5Theme.Primary.getColor())
            .fontFamily(Template5Constants.FONT_FAMILY_CRAFT)
            .margin(bottom = 24.px)
            .maxWidth(620.px)
            .toAttrs()
    ) {
        AnjurosText(LocalText( ResKey.TEMPLATE5_ABOUT_INTRO2), Template5CompanyDetails.CLIENTS_COMPANY_NAME)
    }
}

@Composable
private fun Template5AboutAchievements(
    opacity: Float
) {

    Column(
        verticalArrangement = Arrangement.spacedBy(28.px)
    ) {

        Template5Achievement.entries.forEach { template5Achievement ->
            Template5AchievementCard(
                template5Achievement =template5Achievement,
                opacity = opacity
            )

        }

    }

}

@Composable
private fun Template5AchievementCard(
    template5Achievement: Template5Achievement,
    opacity: Float
) {

    Row(
        verticalAlignment = Alignment.CenterVertically
    ) {

        Column(
            modifier = Modifier.margin(left = 20.px)
                .opacity(opacity)
                .transition(Transition.of("opacity", 500.ms, delay =
                when(
                    template5Achievement.ordinal
                ){
                    0->2400.ms
                    1->2900.ms
                    else->3400.ms
                }))
        ) {

            Span(
                attrs = Modifier
                    .fontSize(38.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Template5Theme.Primary.getColor())
                    .toAttrs()
            ) {
                Text(template5Achievement.value)
            }

            Span(
                attrs = Modifier
                    .fontSize(18.px)
                    .color(rgb(110, 110, 110))
                    .toAttrs()
            ) {
                Text(LocalText(template5Achievement.text))
            }

        }

    }

}
